import React from "react"
import { CampaignIdentity } from "lib/types/generated/graphql-types"
import { Id, RuleContainer } from "./Shared.styled"
import { Link } from "react-router-dom"

type Props = {
  campaign: CampaignIdentity
}

const Campaign = ({ campaign }: Props) => {
  return (
    <RuleContainer>
      <div>
        <b>Campaign: {campaign?.name}</b>
        <Id>
          Campaign id: <Link to={`/campaigns/${campaign?.campaignId}`}>{campaign?.campaignId}</Link>
        </Id>
      </div>
    </RuleContainer>
  )
}

export default Campaign
